import { Dispatch, SetStateAction, createContext } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import utils from 'utils';

type DataRoomSelectedDocumentsContextValues = {
  selected: DataRoomNode[];
  isAllSelected: boolean;
  isSingleSelected: boolean;
  selectedLabel: 'filesSelected' | 'foldersSelected' | 'itemsSelected';
  hasAuthorizedActionsForAllSelected: boolean;
  shouldRename: boolean;
  shouldNotManage: boolean;
  shouldAllowBulkActions: boolean;
  isSingleSelectedFolder: boolean;
  isSingleSelectedVideo: boolean;
  canDownloadSelected: boolean;
  isSelectedMode: boolean;
  canShareFiles: boolean;
  setSelected: Dispatch<SetStateAction<DataRoomNode[]>>;
  onSelect: (node: DataRoomNode) => void;
  updateSelected: (node: DataRoomNode) => void;
  updateSelectedValue: (node: Partial<DataRoomNode>) => void;
  selectAll: () => void;
  removeAll: () => void;
};

export default createContext<DataRoomSelectedDocumentsContextValues>({
  selected: [],
  isAllSelected: false,
  isSingleSelected: false,
  selectedLabel: null,
  hasAuthorizedActionsForAllSelected: false,
  shouldRename: false,
  shouldNotManage: false,
  shouldAllowBulkActions: false,
  isSingleSelectedFolder: false,
  isSingleSelectedVideo: false,
  canDownloadSelected: false,
  isSelectedMode: false,
  canShareFiles: false,
  setSelected: utils.noop,
  onSelect: utils.noop,
  updateSelected: utils.noop,
  updateSelectedValue: utils.noop,
  selectAll: utils.noop,
  removeAll: utils.noop,
});
